import React from 'react';
import { Routes, Route, Link } from 'react-router-dom';
import { Box, Button } from '@mui/material';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import ServiceDetail from './pages/ServiceDetail';
import Contact from './pages/Contact';
import ResourceCenter from './pages/ResourceCenter';
import Locations from './pages/Locations';
import TownDetail from './pages/TownDetail';
import NotFound from './pages/NotFound';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';

// Resource Detail Pages
import NJRecordingRequirements from './pages/resources/NJRecordingRequirements';
import ClosingCostCalculator from './pages/resources/ClosingCostCalculator';
import ALTAComplianceChecklist from './pages/resources/ALTAComplianceChecklist';
import TitleInsuranceGuide from './pages/resources/TitleInsuranceGuide';
import NJRealEstateGlossary from './pages/resources/NJRealEstateGlossary';
import MiddlesexCountyClosingChecklist from './pages/resources/MiddlesexCountyClosingChecklist';
import TitleSearchManual from './pages/resources/TitleSearchManual';
import FirstTimeBuyerMiddlesex from './pages/resources/FirstTimeBuyerMiddlesex';
import NJTitleRateCalculator from './pages/resources/NJTitleRateCalculator';
import TitleDefectsGuide from './pages/resources/TitleDefectsGuide';
import CommercialTitleProcess from './pages/resources/CommercialTitleProcess';
import TitleInsuranceClaimsProcess from './pages/resources/TitleInsuranceClaimsProcess';
import EscrowProcessExplained from './pages/resources/EscrowProcessExplained';
import TitleTemplates from './pages/resources/TitleTemplates';
import DeedStorageGuide from './pages/resources/DeedStorageGuide';
import EscrowManagementGuide from './pages/resources/EscrowManagementGuide';
import ClosingWorkflowTemplate from './pages/resources/ClosingWorkflowTemplate';

import './App.css';

const App: React.FC = () => {
  return (
    <Box
      className="App"
      sx={{
        // Reserve space on mobile so the sticky CTA bar never covers the
        // footer's last content (bar is ~72px tall).
        pb: { xs: '76px', md: 0 },
      }}
    >
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/:serviceSlug" element={<ServiceDetail />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/resources" element={<ResourceCenter />} />
          
          {/* Resource Detail Pages */}
          <Route path="/resources/nj-recording-requirements" element={<NJRecordingRequirements />} />
          <Route path="/resources/closing-cost-calculator" element={<ClosingCostCalculator />} />
          <Route path="/resources/alta-compliance-checklist" element={<ALTAComplianceChecklist />} />
          <Route path="/resources/title-insurance-woodbridge" element={<TitleInsuranceGuide />} />
          <Route path="/resources/nj-real-estate-glossary" element={<NJRealEstateGlossary />} />
          <Route path="/resources/middlesex-county-closing-checklist" element={<MiddlesexCountyClosingChecklist />} />
          <Route path="/resources/title-search-manual" element={<TitleSearchManual />} />
          <Route path="/resources/first-time-buyer-middlesex" element={<FirstTimeBuyerMiddlesex />} />
          <Route path="/resources/nj-title-rate-calculator" element={<NJTitleRateCalculator />} />
          <Route path="/resources/title-defects-guide" element={<TitleDefectsGuide />} />
          <Route path="/resources/commercial-title-process" element={<CommercialTitleProcess />} />
          <Route path="/resources/title-claims-process" element={<TitleInsuranceClaimsProcess />} />
          <Route path="/resources/escrow-process-explained" element={<EscrowProcessExplained />} />
          <Route path="/resources/title-templates" element={<TitleTemplates />} />
          <Route path="/resources/deed-storage-guide" element={<DeedStorageGuide />} />
          <Route path="/resources/escrow-management-guide" element={<EscrowManagementGuide />} />
          <Route path="/resources/closing-workflow-template" element={<ClosingWorkflowTemplate />} />
          
          <Route path="/locations" element={<Locations />} />
          <Route path="/locations/:townSlug" element={<TownDetail />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />

      {/* Mobile-only sticky bottom CTA bar */}
      <Box
        sx={{
          display: { xs: 'block', md: 'none' },
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 1050, // above page content, below drawer (1200) and modal (1300)
          backgroundColor: '#ffffff',
          borderTop: '1px solid #e2e8f0',
          p: 1.5,
        }}
      >
        <Button
          variant="contained"
          fullWidth
          component={Link}
          to="/contact"
          sx={{
            background: 'linear-gradient(90deg, #f59e0b 0%, #fbbf24 50%, #f59e0b 100%)',
            color: '#1f2937',
            py: 1.25,
            fontSize: '0.9375rem',
            fontWeight: 700,
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
            boxShadow: 'none',
            '&:hover': {
              background: 'linear-gradient(90deg, #d97706 0%, #f59e0b 50%, #d97706 100%)',
              boxShadow: '0 4px 16px rgba(245, 158, 11, 0.4)',
            },
            '&:active': {
              transform: 'scale(0.98)',
            },
          }}
        >
          Get Free Quote
        </Button>
      </Box>
    </Box>
  );
};

export default App; 